import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { NotificationManager } from "react-notifications";
import { AddSamplesToBatch } from "../../services/BatchService";
import ScannerInput from "./ScannerInput";

const AddSamplesDialog = ({ open, onClose, batch, onSave,model }) => {    
  const [samples, setSamples] = useState([]);
  const [newSamples, setNewSamples] = useState([]);

  useEffect(() => {
    if (batch) {
      setSamples(batch.map(sample => sample.sampleLabId));
    }
  }, [batch]);

  const handleScan = (scan) => {
    if (samples.includes(scan) || newSamples.includes(scan)) {
      NotificationManager.error("Sample ID already exists in the batch.");
    } else {
      setNewSamples([...newSamples, scan]);
    }
  };

  const removeScan = (scan) => {
    setNewSamples(newSamples.filter((sample) => sample !== scan));
  };

  const createMicroResultSubmissions = (historyEntry) => {
    if (!batch.length) return [];

    const batchInfo = batch[0];
    return newSamples.map(sampleLabId => ({
      batchId: batchInfo.batchId,
      id: null,
      inTime: batchInfo.inTime || null,
      type: batchInfo.type || null,
      sampleLabId: sampleLabId,
      ecoli: batchInfo.ecoli || null,
      coliform: batchInfo.coliform || null,
      hpc: batchInfo.hpc || null,
      result: batchInfo.result || null,
      imageBase64: batchInfo.imageBase64 || null,
      comments: batchInfo.comments || null,
      outUser: batchInfo.outUser || null,
      outTime: batchInfo.outTime || null,
      inUser: batchInfo.inUser || null,
      location: batchInfo.location || null,
      reviewed: batchInfo.reviewed || false,
      reviewComment: batchInfo.reviewComment || "",
      batchEditHistory: historyEntry,
    }));
  };

  const handleSaveClick = async () => {    
    let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser")).operator;
    const newSamplesString = newSamples.join(", ");
    const timestamp = new Date().toLocaleString();
    const historyEntry = `At Micro Out ${newSamples.length} new sample${newSamples.length > 1 ? "s" : ""} having Labels ${newSamplesString} added by ${loggedInUser} on ${timestamp}.`;

    const updatedBatch = {
      ...batch[0],
      batchEditHistory: model.batchEditHistory+ historyEntry +"(At Micro Out)_____",
    };

    const newSubmissions = createMicroResultSubmissions(updatedBatch.batchEditHistory);

    try {
      const response = await AddSamplesToBatch(newSubmissions, newSubmissions[0].batchId);
      onSave(response); // Pass the response to the onSave callback
      onClose();
      NotificationManager.success("Samples added successfully");
    } catch (error) {
      NotificationManager.error("Failed to add samples:", error.message);
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Add New Samples to Batch</DialogTitle>
      <DialogContent>
        <div className="columns">
          <div className="column">
            <label htmlFor="" className="label">
              Scanner Input
            </label>
            <ScannerInput onScanComplete={handleScan} />
          </div>
        </div>
        <table className="table is-striped is-fullwidth">
          <thead>
            <tr>
              <td className="is-bold">New Batch - {newSamples.length} samples</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {newSamples
              .sort((a, b) => {
                try {
                  const aSections = a.split("-");
                  const bSections = b.split("-");
                  if (aSections.length > 1) {
                    if (aSections[0] > bSections[0]) return 1;
                    if (aSections[0] === bSections[0]) {
                      return parseInt(aSections[1]) > parseInt(bSections[1]) ? 1 : -1;
                    }
                    return -1;
                  }
                  return 1;
                } catch (err) {
                  console.log(err);
                  return 0;
                }
              })
              .map((item) => (
                <tr key={item}>
                  <td>
                    <span>{item}</span>
                  </td>
                  <td className="has-text-right">
                    <button
                      className="button is-small is-rounded is-danger is-bold"
                      onClick={() => removeScan(item)}
                    >
                      X
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button 
          onClick={handleSaveClick} 
          variant="contained" 
          color="primary"
          disabled={newSamples.length === 0}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSamplesDialog;
